export const PUBLIC_LINKS = Object.freeze({
  freeFuture: "https://www.freefuture.eu/",
  xaiSchool: "https://www.xaischool.eu/",
  xaiSchoolAssessment: "https://www.xaischool.eu/test-ingresso?course=prompt-con-metodo",
  xaiSchoolLogin: "https://www.xaischool.eu/login",
  contactEmail: "mailto:max@freefuture.eu",
  contactEmailLabel: "max@freefuture.eu",
  contactPhone: "tel:+393348432194",
  contactPhoneLabel: "+39 334 8432194",
  privacyEmail: "mailto:max@freefuture.eu",
  support:
    "https://www.freefuture.eu/assistenza/richiesta/?progetto=ilconsulenteai.it",
});
